import type { GeneratorId, IdleState } from "@/game/model/idle-state";

const GENERATOR_FOCUS_PER_LEVEL: Record<GeneratorId, number> = {
  breath: 0.25,
  journal: 0.6,
};

export function recomputeRates(state: IdleState): IdleState {
  let focusPerSecond = 0.5;
  for (const gen of state.generators) {
    focusPerSecond += gen.level * GENERATOR_FOCUS_PER_LEVEL[gen.id];
  }
  const clickPower = 1 + Math.floor(state.resources.focus / 50) * 0.5;
  return { ...state, focusPerSecond, clickPower };
}

export function clarityPerSecond(focusPerSecond: number): number {
  return focusPerSecond * 0.02;
}

export function resiliencePerSecond(clarity: number): number {
  return clarity > 10 ? 0.01 : 0;
}
